import { RegisterOptions, useFormContext } from "react-hook-form";
import SelectCategoriaAtendimento from "../../CardsPages/Forms/SelectCategoriaAtendimento";

type SelectProp = Parameters<typeof SelectCategoriaAtendimento>[0];

interface IFormSelectCategoriaAtendimentoProps extends SelectProp {
    name: string;
    registerOptions?: RegisterOptions;
    defaultValue?: number;
}

export default function FormSelectCategoriaAtendimento(
    props: IFormSelectCategoriaAtendimentoProps
) {
    const { control } = useFormContext();

    return (
        <SelectCategoriaAtendimento
            {...props}
            control={control}
            rules={props.registerOptions}
        />
    );
}
